// The wire value of `address_type` is not what the subscriber chose.
//
// In the subscriber app (eci-subscription) the address form offers three tabs — Home / Office /
// Other — and maps them to different wire values before sending: `Home -> resident`,
// `Office -> company`, and "Other" is replaced by whatever free text the subscriber typed.
// So any admin screen that merely capitalizes the raw value shows ops "Resident" for an address
// the subscriber tagged "Home", and ops and subscriber end up describing the same address
// differently.
//
// This map is the same one eci-subscription uses (src/utils/formatAddressType.js there) — keep
// them in step. Admin's own address forms currently send 'home' / 'office' / 'other' directly,
// which pass through unchanged, so both conventions land on the same label.
const ADDRESS_TYPE_LABELS = {
  resident: 'Home',
  company: 'Office',
  home: 'Home',
  office: 'Office',
  other: 'Other',
};

/**
 * Wire `address_type` -> the label the subscriber actually chose.
 *
 * A custom "Other" value (e.g. "farmhouse") is not in the map and falls through capitalized,
 * which is exactly what should be shown. Returns '' for a missing value so callers can keep
 * using a plain truthiness check before rendering the badge.
 */
export const formatAddressType = (type) => {
  if (!type || typeof type !== 'string') return '';

  const trimmed = type.trim();
  if (!trimmed) return '';

  return ADDRESS_TYPE_LABELS[trimmed.toLowerCase()]
    || trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

export default formatAddressType;
